import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';
import { fetchDeparture } from "api/portal/index";
import { withRouter } from "react-router-dom";

class Departurelist extends Component {
  constructor(props) {
    super(props);
    const { gid } = this.props;
    this.state = {
      datatable: this.props.datatable,
      gid: gid
    };
  }

  componentWillMount(){
    fetchDeparture(this.state.gid)
      .then(response => {

          this.setState({datatable:response.data});
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

  }

  render() {
    const columns = [
      {
        name: "MMSI",
        label: "MMSI",
        options: {
          filter: true,
          display: true
        }
      },
      {
        name: "SHIPNAME",
        label: "SHIPNAME",
        options: {
          filter: true
        }
      },
      {
        label: "SHIP_ID",
        name: "SHIP_ID",
        options: {
          filter: true
        }
      },
      {
        label: "TIMESTAMP LT",
        name: "TIMESTAMP_LT",
        options: {
          filter: true
        }
      },
      {
        label: "TIMESTAMP UTC",
        name: "TIMESTAMP_UTC",
        options: {
          filter: true
        }
      },
      {
        label: "TYPE NAME",
        name: "TYPE_NAME",
        options: {
          filter: true
        }
      },
      {
        label: "PORT NAME",
        name: "PORT_NAME",
        options: {
          filter: true
        }
      },
      {
        label: "UNLOCODE",
        name: "UNLOCODE",
        options: {
          filter: true
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll"
    };

    return (
      <MUIDataTable
        title = {this.state.gid}
        data={this.state.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default withRouter(Departurelist);
